export default {
  updateProjects: false,
};
